/**
 * Channel service is used for global exchanges between editor and server.
 */
fx.service( class Channel extends fx.Service {

    constructor(model)
    {
        super();
        this.model = model.creationModel;
        this._activated = false;
        this._data = {bookid: this.model.creation.id, sessionid: fx.get("connectionid")};
    }  

    get data()
    {
        return this._data;
    }

    activate(){
        if(!this._activated)
        {
            this._activated = true;
            this.delay(this.refresh, 5000);
        }
    }

    deactivate(){
        if(this._activated)
        {
            this._activated = false;
            this.delay(this.refresh, null);
        }
    }

    refresh()
    {
        this.post("/app/channel/",
        {
            data: this.data
        }, this._response);
    }

    send(data)
    {
        let mergedData = {...this.data, ...data};
        this.post("/app/channel/",
        {
            data: mergedData
        }, this._response);
    }

    _response(data)
    {
        if (data.error)
        {

        }
        else
        {
            if (data.sharedPhoto)
                this.trigger("new-photos", data.sharedPhoto);            
        }
        this.delay(this.refresh, 60000);
    }

});

